import { OG_IMAGE_PATH, absoluteUrl, matchRoute, robotsContent } from '../server/seo/routes-meta';

// El BFF escribe og:image con APP_PUBLIC_URL; sin BFF (desarrollo) se usa el origen actual.
function resolveBaseUrl () {
    const ogImage = document.head.querySelector('meta[property="og:image"]');
    const content = ogImage && ogImage.getAttribute('content');

    if (content && content.endsWith(OG_IMAGE_PATH)) {
        return new URL(content, window.location.origin).href.slice(0, -OG_IMAGE_PATH.length);
    }

    return window.location.origin;
}

let baseUrl = null;

let jsonLd = null;

function syncJsonLd (path) {
    if (jsonLd === null) {
        const script = document.head.querySelector('script[type="application/ld+json"]');
        jsonLd = { path, script };
    }

    const { script } = jsonLd;
    if (!script) return;

    if (path === jsonLd.path) {
        if (!script.parentNode) document.head.appendChild(script);
    } else if (script.parentNode) {
        script.parentNode.removeChild(script);
    }
}

function setHeadElement (selector, create, attribute, value) {
    let element = document.head.querySelector(selector);

    if (!value) {
        if (element) element.parentNode.removeChild(element);
        return;
    }

    if (!element) {
        element = create();
        document.head.appendChild(element);
    }

    element.setAttribute(attribute, value);
}

function setMetaTag (attribute, key, content) {
    setHeadElement(`meta[${attribute}="${key}"]`, () => {
        const meta = document.createElement('meta');
        meta.setAttribute(attribute, key);
        return meta;
    }, 'content', content);
}

function setCanonical (href) {
    setHeadElement('link[rel="canonical"]', () => {
        const link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        return link;
    }, 'href', href);
}

export function applyRouteMeta (route) {
    if (baseUrl === null) baseUrl = resolveBaseUrl();

    const meta = matchRoute(route.path);
    const canonical = absoluteUrl(baseUrl, meta.path);

    document.title = meta.title;

    setCanonical(canonical);
    setMetaTag('property', 'og:url', canonical);
    setMetaTag('property', 'og:title', meta.title);
    setMetaTag('name', 'twitter:title', meta.title);
    setMetaTag('name', 'description', meta.description);
    setMetaTag('property', 'og:description', meta.description);
    setMetaTag('name', 'twitter:description', meta.description);
    setMetaTag('name', 'robots', robotsContent(meta.indexable));
    syncJsonLd(route.path);
}
